
Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Stops = Greenmile.RouteSummary.Stops || {};
Greenmile.RouteSummary.Stops.Grid = (function () {

    function Grid () {

        Greenmile.RouteSummary.Grid.apply(this, arguments);

        this.entity = 'RouteSummaryStops';
        this.containerGrid = "#RouteSummary #stopsGrid #grid";
        this.entityToActionGrid = 'StopView';
        this.countCustomColumns = 1;

        this.getInstanceOfMenu = function () {

            return new Greenmile.RouteSummary.Stops.Menu();

        };

        this.getColumns = function (callback) {
            var columnProvider = new Greenmile.GridColumns.Stop();
            columnProvider.setEntity(this.entity);

            columnProvider.getColumns(callback);
        };
    }

    return Grid;

}());
